// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_bw-b";
export var colorBlue = "_bw-8";
export var colorDot = "_bw-0";
export var colorDotLarge = "_bw-2";
export var colorDotSmall = "_bw-1";
export var colorGreen = "_bw-7";
export var colorGrey = "_bw-3";
export var colorOrange = "_bw-5";
export var colorPink = "_bw-a";
export var colorPurple = "_bw-9";
export var colorRed = "_bw-4";
export var colorYellow = "_bw-6";